module.exports = {
  not_found: {
    title: 'Something went wrong',
    description: 'Page not found. Error 404',
    linkText: 'if the error persists',
    link: 'contact us',
    please: 'Please'
  },
  premium: 'Premium',
  get_premium: 'Get premium',
  sign_in: 'Sign In',
  sign_out: 'Sign Out',
  need_sign_in: 'Need to sign in',
  learn_more: 'Learn More',
  cancel: 'Cancel',
  ok: 'Ok',
  edit: 'Edit',
  remove: 'Remove',
  save: 'Save',
  submit: 'Submit',
  back: 'Back',
  forgot: 'Forgot password',
  functionality: 'features',
  for_more: 'For extra',
  years: 'years',
  get_started: 'Get Started',
  url_exists: 'This url already exists',
  links_list: 'in your links list',
  locked: 'Lock',
  unlocked: 'Unlock',
  lock: 'Lock',
  unlock: 'Unlock',
  now: 'now',
  parent_dashboard: {
    title: 'Parent\'s Dashboard',
    tooltip: 'The Parent\'s Dashboard allows you to observe your child\'s online activity, and change the settings to suit your needs.',
    welcome: 'Welcome back to the workspace, we missed you!',
    switch_mode_btn: 'Switch to Kids Mode',
  },
  menu: {
    settings: {
      title: 'Settings',
      description: 'Customize all of the Kid\'s Mode settings to best suit you.'
    },
    sites: {
      title: 'Sites',
      description: 'Here you can add and remove the sites your kids will be able to access online.'
    },
    themes: {
      title: 'Backgrounds',
      description: 'Choose the background that will keep your kid the most happy and entertained.'
    },
    statistics: {
      title: 'Statistics',
      description: 'See how much time your kid is spending online, and on which sites.'
    },
    remote: {
      title: 'Remote Access',
      description: 'Stay in control over what your kid is doing online, wherever you are.'
    }
  },
  settings: {
    title: 'Settings',
    kid_info: {
      title: 'Kid\'s info',
      kid_name: 'Kid\'s name',
      kid_age: 'Kids age'
    },
    unlock_method: {
      title: 'Unlock method',
      tooltip: 'Choose your preferred method to switch between Kids Mode and Parent\'s Mode.',
      math: 'Simple Math',
      password: 'Password',
      example: 'Example',
      default: 'Default',
      for_set_pas: 'In order to set your password, please',
      math_description: 'Switch between Parents Mode and Kids Mode by solving a simple mathematical question',
      password_description: 'Switch between Parents Mode and Kids Mode by entering a password',
    },
    lock_configuration: {
      title: 'Lock Settings',
      tooltip: 'Choose your lock setting to set when Kids Mode will be activated on your browser.',
      lock_start: 'Lock when start',
      lock_start_desc: 'Kids lock is activated automatically every time the browser restart',
      auto_lock: 'Lock Automatically',
      auto_lock_desc: 'If there is no activity with the browser, turn on the Kids mode after X min automatically',
      always_top: 'Kids Lock Pinned',
      always_top_desc: 'Kid\'s Lock will be the only screen accessible for your kids, so everything else on your computer can stay safe and secure.',
    },
    remote_lock: {
      title: 'Remote Lock',
      tooltip: 'Control your child\'s online access from a distance with our remote lock feature.',
      give_time: 'Give bonus time',
      unlock_by_unavailable_settings: 'To unlock KidsMode, please, change restricted times settings or daily limit',
    },
    daily_limit: {
      title: 'Daily Limit',
      tooltip: 'Set the maximum number of hours your child can spend online and once they have reached this their access will be blocked.',
      block_description: 'For younger children, age 5 to 8, the recommended limit is one hour per day. For kids age 9 to 12 the new warning from the AHA recommends parents limit screen time for kids to a maximum of just two hours per day.',
    },
    unavailable: {
      title: 'Restricted Times',
      tooltip: 'Set time frames for Kids Mode to be available for your children, allowing them to spend a healthy amount of time online.',
      edit: 'Edit Restricted Times',
      error: 'Time from must be less that time to',
      additional_main_error: 'Additional time range should be out of main range',
      additional_time_range: 'Additional time range',
      block_day: 'Block all day',
      from: 'From',
      to: 'To',
    }
  },
  sites: {
    title: 'Sites',
    sites_description: 'The internet can be great a great tool for kids. Online they can communicate with teachers and friends, research, learn and play. However spending time online is not without risks, and we are here to help minimise these for you.',
    allow_kid_to_request: 'Allow kids to request access to site',
    allow_kid_to_request_tooltip: 'To use this feature you have to check if your operating system supports notification displaying via the selected browser and the required option in system preferences was turned on',
    allow_kid_to_request_desc: 'Permit your kids to send a request to visit sites not on their list. You can then choose whether to approve or deny. ',
    add_links: 'Add approved links',
    add_links_desc: 'Choose the websites your kid will be able to access',
    useful_websites: 'Recommended useful sites',
    preview: 'Preview',
    add_to_list: 'Add to list',
    oops: 'Oops...',
    can_add_10_links: 'You can only add 10 links',
    to_add_remove: 'To add this, first remove any of the existing',
  },
  themes: {
    title: 'Backgrounds',
    choose_theme: 'Choose the theme based on your kids interest',
    upload_image: 'Upload image',
  },
  statistic: {
    daily_limit: 'Daily limit',
    daily_usage: 'Daily usage',
    last_week: 'Last week',
    last_month: 'Last month',
    week_activity: 'Weekly Activity',
    activity_history: 'Activity History',
    activity_history_tooltip: 'Check up on your kids online activity history and internet usage so you know your child is staying safe and healthy online.',
    activity_history_last: 'Activity history for the last',
    days: 'days',
    today: 'Today',
    week: 'Week',
    month: 'Month',
    site_request: 'has made a request to provide access to this site',
    site_request_accept: 'Accept the site',
    site_request_block: 'Block the site',
    time_request: 'Kid asks you to allow more time',
    time_request_text: 'has made a request to provide access to this site',
    unavailable_request_text: 'If you want to add time - change unavailable settings',
    go_settings: 'Go to settings',

  },
  remote: {
    title: 'Remote Access',
    description: 'Choose when your kids have access online by locking or unlocking their usage as you see fit.',
    locked_until: 'Locked until',
    remote_lock: 'Remote Lock',
    features: {
      title: 'Features',
      premium: 'To access these features, you must purchase a premium',
      feature_1_title: 'Access dashboard from phone',
      feature_1_text: 'Stay in control of all features, wherever you are.',
      feature_2_title: 'Get additional time for kids or lock screen remotely',
      feature_2_text: 'Choose how much time your kid is spending on the web, and on which sites.',
      feature_3_title: 'Check Statistics',
      feature_3_text: 'Stay up to date with advanced statistics about your kid\'s web usage.',
    }
  },
  only_premium: {
    try_premium: 'Try Premium',
    only_for_premium: 'Only for premium users',
    only_premium_description: 'This feature, like many others, is only available for premium accounts.',
  },
  add_link_modal: {
    link: 'link',
    create_link: 'Create custom link',
    enter_link_title: 'Enter link title',
    enter_link_url: 'Enter link url',
    create_link_desc: 'Create link to sites you choose, you can add title url',
    only_premium_description: 'This feature, like many others, is only available for premium accounts.',
  },
  get_premium_modal: {
    title: 'Get Premium',
    titleAndroid: 'Premium subscription',
    monthly: 'Monthly',
    yearly: 'Yearly',
    total: 'Total',
    per_month: 'per month',
    save_20: 'Save 20%',
    percent_off: '20% off',
    get: 'Get',
    two_month_free: '2 months free',
    billing_info: 'Billing information',
    card_text_info: 'Card information is stored on a secure server',
    wait_please: 'Wait, please',
    already_have_premium: 'I already have premium account',
    mobile_only_for_premium: 'Mobile version available only for premium user',
    sign_in_before_get_premium: 'You need to sign in before get premium',
    help: 'Help',
    features: {
      title: 'What do you get with premium',
      feture_1_title: 'Extra Settings',
      feture_1_texts: ['Auto lock', 'Remote lock', 'Always on top', 'Time limit'],
      feture_2_title: 'More Backgrounds',
      feture_2_texts: ['Animated backgrounds', 'Upload your background'],
      feture_3_title: 'Detailed Statistics',
      feture_3_texts: ['Configurate date range (week/month or custom date)'],
      feture_4_title: 'Remote Access',
      feture_4_texts: ['Access dashboard from web', 'Give additional time for kids or lock screen remotely', 'Check statistic and generate custom link that no need login'],
    }
  },
  premium_success_modal: {
    button: 'Let\'s rock',
    text_part_1: 'Yeah!',
    text_part_2: 'Thanks for subscribing!',
    text_part_3: 'Welcome to the premium family!'
  },
  premium_page: {
    title: 'Premium',
    free: 'Free',
    premium: 'Premium',
    description: 'To access these features, you must purchase a premium',
    features: {
      settings: 'Settings',
      settings_additional: {
        lock_when_start: 'Lock when start',
        auto_lock: 'Auto lock',
        remote_lock: 'Remote lock',
        always_top: 'Always on top(kids can only see this app)',
        time_limit: 'Time limit daily for all app',
        screen_time: 'Screen time',
      },
      themes: 'Backgrounds',
      themes_additional: {
        some_theme: 'Some background',
        animated_themes: 'Animated backgrounds',
        upload_bg: 'Upload your background',
      },
      statistic: 'Statistic',
      statistic_additional: {
        configurate_date_range: 'Configurate date range (week/month or custom date)',
      },
      remote_features: 'Remote access features',
      remote_features_additional: {
        access_dashboard_from_web: 'Access dashboard from web',
        get_add_time_remotely: 'Get additional time for kids or lock screen remotely',
        check_stat: 'Check statistic and generate custom link that no need login',
      },
      sites: 'Sites',
      sites_additional: {
        add_links_allow: 'Add links to allow kids',
        allow_kid_request: 'Allow kids to request access to site',
      }
    }
  },
  kid: {
    parent_mode: 'Parent Mode',
    welcome_back: 'Welcome back!',
    welcome_to: 'Welcome to',
    i_am_child: 'I am a CHILD',
    i_am_parent: 'I am a PARENT',
    screen_locked: 'Screen is locked',
    time_over: 'Time\'s Up!',
    kid_sent_request: 'You already sent request',
    give_more_time: 'I\'d like more time',
    choose_child_age: 'Choose Age Range',
    choose_age_description1: 'For The Younger Kids',
    choose_age_description2: 'For The Kids Wanting To Learn A Bit More',
    choose_background: 'Choose Your Favourite Background',
    choose_background_description: 'Choose from more backgrounds later on, or add your own.',
    recommended_links_title: 'Select Your Favourites From Our Recommended Links',
    recommended_links_description: 'You can choose more links after, or create your own.',
    choose_lock_configuration: 'Choose Your Lock Setting',
    configuration_complete: 'Set Up Complete!',
    configuration_complete_desc: 'Please wait a few seconds as we prepare your personalised dashboard.',
    next: 'Next',
    login: {
      math_placeholder: 'Enter your answer',
      math_error: 'Your answer is invalid. Please try again',
      pas_placeholder: 'Enter your password',
      pas_error: 'Your password is invalid. Please try again',
      pas_change_sign_in: 'if you want to set different password, you need to',
    },
    forgot: {
      forgot_pas: 'Forgot password?',
      your_pas_is: 'Your password is',
      enter_email: 'Enter your email',
      forgot_error: 'This email is not registered'
    }
  },
  ext: {
    kid_dont_has_access: 'You don\'t have access to this site',
    kid_want_visit_site: 'Need to visit the site? Let\'s ask an adult if it\'s ok first'
  },
  android: {
    permissionSlide: {
      title: 'Permission required',
      label: 'The app need Always on top permission to work properly',
      finish_settings: 'finish base settings'
    }
  }
}
